import * as React from "react";
import {useId} from "react";
import {Input} from "@/components/ui/input.tsx";
import {cn} from "@/lib/utils.ts";
import {CloudUpload} from "lucide-react";
import {Label} from "@/components/ui/label.tsx";


export default function FileInputField(
    {onFileSelected, label, labelClassName, ...props}:
        {
            onFileSelected: (file: File) => void;
            label?: string;
            labelClassName?: string;
        } & React.ComponentProps<"input">) {

    const id = useId()

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        onFileSelected(file);
    }

    return (
        <Label title={label ?? "Hochladen"} className={cn("flex items-center justify-center gap-2 cursor-pointer",
            "rounded-sm border bg-foreground text-black hover:bg-white/80",
            label ? "h-8 px-3 text-sm font-medium" : "size-7",
            labelClassName)}>
            <CloudUpload size={18}/>
            {label}
            <Input {...props} type="file" id={id}
                   className="hidden" onChange={handleOnChange}/>
        </Label>
    )
}
